export const INVOICE_SERVICE = {
  MONTHLY_GGR: 'MONTHLY_GGR',
  MKT_FREE_SPIN: 'MKT_FREE_SPIN',
  DAILY_PROGRAM: 'DAILY_PROGRAM',
};

export const PAYMENT_STATUS = {
  UNPAID: 'UNPAID',
  PROCESSING: 'PROCESSING',
  PAID: 'PAID',
  CANCELED: 'CANCELED',
  FAILED: 'FAILED',
  WAIVED: 'WAIVED',
};

export const INVOICE_STATUS = {
  OPEN: 'OPEN',
  VALIDATED: 'VALIDATED',
  COMPLETED: 'COMPLETED',
  CANCELED: 'CANCELED',
};

export const PAYMENT_CHANNEL = {
  USDT_ERC: 'USDT_ERC',
  USDT_TRC20: 'USDT_TRC20',
};

export const PAYMENT_METHOD = {
  OFFLINE_PAYMENT: 'OFFLINE_PAYMENT',
  USDT: 'USDT',
};

export const INVOICE_EXPORT_FILE_TYPE = {
  INVOICE_PDF: 'INVOICE_PDF',
  INVOICE_DETAIL_XLSX: 'INVOICE_DETAIL_XLSX',
};

export const EXPORT_FILE_TYPE = {
  PDF: 'PDF',
  XLSX: 'XLSX',
};

export const ACCOUNT_STATEMENT_TRANSACTION_TYPE = {
  INVOICE: 1,
  PAYMENT: 2,
};
